module.exports = __webpack_public_path__ + "static/SelectScreen-0f69fe50e7ca209d0e94070132a8a10b.png";